import { DraftFullId } from "../../../../Common/CandyApiClient/Types/DraftFullId";
import { PanelType } from "../../Controls/FormParts/Panel/PanelTypes";

type PanelStateStore = Array<[draftKey: string, panelType: PanelType]>;

const storageKey = "Candy:PanelStates";

export function savePanelStateToLocalStorage(draftId: DraftFullId, panelState: PanelType): void {
    if (typeof localStorage == "undefined") {
        return;
    }
    try {
        const panelStates = JSON.parse(localStorage.getItem(storageKey) ?? "[]") as PanelStateStore;
        const currentItem = panelStates.find(x => x[0] === `${draftId.ns}_${draftId.draftId}`);
        if (currentItem == undefined) {
            panelStates.push([`${draftId.ns}_${draftId.draftId}`, panelState]);
        } else {
            currentItem[1] = panelState;
        }
        if (panelStates.length > 5) {
            panelStates.unshift();
        }
        localStorage.setItem(storageKey, JSON.stringify(panelStates));
    } catch {
        // ignore errors
    }
}

export function getPanelStateToLocalStorage(draftId: DraftFullId): undefined | PanelType {
    try {
        const panelStates = JSON.parse(localStorage.getItem(storageKey) ?? "[]") as PanelStateStore;
        return panelStates.find(x => x[0] === `${draftId.ns}_${draftId.draftId}`)?.[1];
    } catch {
        return undefined;
        // ignore errors
    }
}
